"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

var _Heading = _interopRequireDefault(require("../../../protons/typography/heading/Heading"));

var _BadgeNumber = _interopRequireDefault(require("../../../atoms/badges/badgeNumber/BadgeNumber"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

var _Paragraph = _interopRequireDefault(require("../../../protons/typography/paragraph/Paragraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardChat = function CardChat(_ref) {
  var title = _ref.title,
      date = _ref.date,
      message = _ref.message,
      icon = _ref.icon,
      badgeCount = _ref.badgeCount,
      action = _ref.action;
  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    elevation: 0,
    className: (0, _classnames.default)({
      'MuiCard-chat': true
    })
  }, /*#__PURE__*/_react.default.createElement(_core.CardActionArea, {
    onClick: function onClick() {
      return action();
    }
  }, /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_BadgeNumber.default, {
    number: badgeCount,
    color: "red",
    size: "medium"
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: icon,
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    title: title,
    variant: "h5bold"
  }), /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    variant: "body1",
    text: date
  })))), message && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    variant: "body1",
    text: message
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
    icon: "placeholder"
  })))))))));
};

var _default = CardChat;
exports.default = _default;